/* eslint-disable no-use-before-define */
import axios from 'axios';
import { toLower, get, isEmpty, has } from 'lodash';
import { push } from 'react-router-redux';
import mixpanel from 'mixpanel-browser';
import store from '../../store';
import * as ActionTypes from './types';
import * as API from '../network/api';
import HHRequest, { HHAxiosRequest } from '../network';
import { HHAlert, hlog, HHEncrypt } from '../common/util';
import { ALERT_TYPE } from '../common/constant';

mixpanel.init('4353f622639bd0bb8d3d932362907e41');

// Helpers
// TODO Clean unused actions
const passBack = (dispatch, res, dispatchType, resPayload) => {
  switch (res.code) {
    case 200:
      dispatch({
        type: dispatchType,
        payload: resPayload
      });
      break;
    default:
      throw res;
  }
};

const standardReturn = res => {
  hlog(res);
  switch (res.code) {
    case 200:
      return res;
    default:
      throw res;
  }
};

export const handleResponseCode = code => {
  if (typeof code !== 'number') {
    hlog('response status code is not a number');
    return;
  }

  switch (code) {
    case 200:
      break; // do nothing
    case 400:
      HHAlert({ id: 'alert.error.unknownError' }, ALERT_TYPE.ERROR);
      break;
    case 4002:
      HHAlert({ id: 'alert.error.missRequiredFields' }, ALERT_TYPE.ERROR);
      break;
    case 4003:
      HHAlert({ id: 'alert.error.invalidToken' }, ALERT_TYPE.ERROR);

      store.dispatch({ type: ActionTypes.USER_LOGOUT });
      store.dispatch(push('/login'));
      break;
    case 4007:
      HHAlert({ id: 'alert.error.noInvalidEmail' }, ALERT_TYPE.ERROR);
      break;
    case 4012:
      HHAlert({ id: 'alert.error.invalidUser' }, ALERT_TYPE.ERROR);
      break;
    case 4014:
      HHAlert({ id: 'alert.error.invalidEmail' }, ALERT_TYPE.ERROR);
      break;
    case 4015:
      HHAlert({ id: 'alert.error.duplicateEmail' }, ALERT_TYPE.ERROR);
      break;
    case 4016:
      HHAlert({ id: 'alert.error.loginNotMatch' }, ALERT_TYPE.ERROR);
      break;
    case 4017:
      HHAlert({ id: 'alert.error.confirmationEmailObjectNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4020:
      HHAlert({ id: 'alert.error.emailNotVerified' }, ALERT_TYPE.ERROR);
      break;
    case 4021:
      HHAlert({ id: 'alert.error.inviteTokenExpired' }, ALERT_TYPE.ERROR);
      break;
    case 4023:
      HHAlert({ id: 'alert.error.duplicateUsername' }, ALERT_TYPE.ERROR);
      break;
    case 4027:
      HHAlert({ id: 'alert.error.failToSaveProfile' }, ALERT_TYPE.ERROR);
      break;
    case 4031:
      HHAlert({ id: 'alert.error.submissionNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4033:
      HHAlert({ id: 'alert.error.notRegister' }, ALERT_TYPE.ERROR);
      break;
    case 4035:
      HHAlert({ id: 'alert.error.stripe.amount' }, ALERT_TYPE.ERROR);
      HHAlert({ id: 'alert.error.stripe.exp_month' }, ALERT_TYPE.ERROR);
      break;
    case 4037:
      HHAlert({ id: 'alert.error.eventNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4038:
      HHAlert({ id: 'alert.error.teamNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4039:
      HHAlert({ id: 'alert.error.teamFull' }, ALERT_TYPE.ERROR);
      break;
    case 4040: {
      HHAlert({ id: 'alert.error.notInTeam' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4041: {
      HHAlert({ id: 'alert.error.notParticipant' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4042: {
      HHAlert({ id: 'alert.error.notTeamLeader' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4043:
      HHAlert({ id: 'alert.error.alreadyAppliedJoinTeam' }, ALERT_TYPE.ERROR);
      break;
    case 4044:
      HHAlert({ id: 'alert.error.userNotInPendingList' }, ALERT_TYPE.ERROR);
      break;
    case 4045: {
      HHAlert({ id: 'alert.error.alreadyInTeam' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4048: {
      HHAlert({ id: 'alert.warning.noUserFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4049: {
      HHAlert({ id: 'alert.warning.maxTeamSize' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4052: {
      HHAlert({ id: 'alert.warning.removeTeamCreator' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4055: {
      HHAlert({ id: 'alert.warning.judgingCriteriaNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4057: {
      HHAlert({ id: 'alert.warning.judgeCriteriaMarkRange' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4059: {
      HHAlert({ id: 'alert.warning.awardAssignLimit' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4060: {
      HHAlert({ id: 'alert.warning.awardAlreadyAssigned' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4058: {
      HHAlert({ id: 'alert.warning.awardNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4061: {
      HHAlert({ id: 'alert.warning.themeNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4062: {
      HHAlert({ id: 'alert.warning.premissionError' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4063: {
      HHAlert({ id: 'alert.warning.roleNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4064: {
      HHAlert({ id: 'alert.warning.alreadyHasRole' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4067: {
      HHAlert({ id: 'alert.warning.ticketNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4069: {
      HHAlert({ id: 'alert.warning.eventEnded' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4070: {
      HHAlert({ id: 'alert.warning.ticketAlreadyPurchased' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4071: {
      HHAlert({ id: 'alert.warning.chargeNotFound' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4072: {
      HHAlert({ id: 'alert.warning.ticketSoldOut' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4077: {
      HHAlert({ id: 'alert.warning.jcMaxScore' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4078: {
      HHAlert({ id: 'alert.warning.teamCreatorCannotLeave' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4083: {
      HHAlert({ id: 'alert.error.nameTooLong' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4084: {
      HHAlert({ id: 'alert.warning.noAttendeeInEvent' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4085: {
      HHAlert({ id: 'alert.warning.accountIsNotVerified' }, ALERT_TYPE.WARNING);
      break;
    }
    case 4086: {
      HHAlert({ id: 'alert.error.invalidPassword' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4087: {
      HHAlert({ id: 'alert.error.phoneAlreadyUsed' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4088: {
      HHAlert({ id: 'alert.error.eventHasEnded' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4090: {
      HHAlert({ id: 'alert.error.resourceNotFound' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4091: {
      HHAlert({ id: 'alert.error.submissionDDLPast' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4092: {
      HHAlert({ id: 'alert.error.noPermission' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4093: {
      HHAlert({ id: 'alert.error.resetPwdCodeNotFound' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4094: {
      HHAlert(
        { id: 'alert.error.someSubmissionsHaveBeenJudged' },
        ALERT_TYPE.ERROR
      );
      break;
    }
    case 4095: {
      HHAlert({ id: 'alert.error.teamNotFoundAlter' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4102: {
      HHAlert({ id: 'alert.error.GroupNotFound' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4103: {
      HHAlert({ id: 'alert.error.unknownThirdParty' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4104: {
      HHAlert({ id: 'alert.error.formTokenUrlError' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4105: {
      HHAlert({ id: 'alert.error.accAlreadyBindWithThirdParty' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4107: {
      HHAlert({ id: 'alert.error.failToSaveInfo' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4110: {
      HHAlert({ id: 'alert.error.failToFetchEmailFromLinkedinAcc' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4111: {
      HHAlert({ id: 'alert.error.failToFetchInsToken' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4112: {
      HHAlert({ id: 'alert.error.ChannelObjectNotFound' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4113: {
      HHAlert({ id: 'alert.error.invalidUserPlan' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4114: {
      HHAlert({ id: 'alert.error.attendeesNumberLimit' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4115: {
      HHAlert({ id: 'alert.error.captchaNotValid' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4116: {
      HHAlert({ id: 'alert.error.CSVFormat' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4117: {
      HHAlert({ id: 'alert.error.CSVFormat' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4118: {
      HHAlert({ id: 'alert.error.failToReadFile' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4121: {
      HHAlert({ id: 'alert.error.removeProfileFailed' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4122: {
      HHAlert({ id: 'alert.error.failToRemoveFromMailChimp' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4125: {
      HHAlert({ id: 'alert.error.invalidDate' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4129: {
      HHAlert({ id: 'alert.error.differentIP' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4130: {
      HHAlert({ id: 'alert.error.loginExpired' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4142: {
      HHAlert({ id: 'alert.error.incorrectRoleWhenDeleteAccount' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4147: {
      HHAlert({ id: 'alert.error.userDataExportInProgress' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4150: {
      HHAlert({ id: 'alert.error.couponCodeExists' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4151: {
      HHAlert({ id: 'alert.error.couponRanOut' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4152: {
      HHAlert({ id: 'alert.error.couponNotFound' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4153: {
      HHAlert({ id: 'alert.error.minTicketPrice' }, ALERT_TYPE.ERROR);
      break;
    }
    case 4135:
      HHAlert({ id: 'alert.error.invalidCoupon' }, ALERT_TYPE.ERROR);
      break;
    case 4154:
      HHAlert({ id: 'alert.error.invalidRoundNumber' }, ALERT_TYPE.ERROR);
      break;
    case 4155:
      HHAlert({ id: 'alert.error.invalidRoundNumber' }, ALERT_TYPE.ERROR);
      break;
    case 4156:
      HHAlert({ id: 'alert.error.submitSelectWrongRound' }, ALERT_TYPE.ERROR);
      break;
    case 4157:
      HHAlert({ id: 'alert.error.submitTeamNotInRound' }, ALERT_TYPE.ERROR);
      break;
    case 4148:
      HHAlert({ id: 'alert.error.fileUploadLimitReached' }, ALERT_TYPE.ERROR);
      break;
    case 4159:
      HHAlert({ id: 'alert.error.createApplicationForm' }, ALERT_TYPE.ERROR);
      break;
    case 4160:
      HHAlert({ id: 'alert.error.refundedSomewhereElse' }, ALERT_TYPE.ERROR);
      break;
    case 4161:
      HHAlert({ id: 'alert.error.payoutMethodAlreadyAdd' }, ALERT_TYPE.ERROR);
      break;
    case 4162:
      HHAlert({ id: 'alert.error.payoutMethodNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4163:
      HHAlert({ id: 'alert.error.noFund' }, ALERT_TYPE.ERROR);
      break;
    case 4164:
      HHAlert({ id: 'alert.error.stripeRelatedAPICallFreq' }, ALERT_TYPE.ERROR);
      break;
    case 4165:
      HHAlert({ id: 'alert.error.stripeRelatedAPICallFreq' }, ALERT_TYPE.ERROR);
      break;
    case 4166:
      HHAlert({ id: 'alert.error.taxRateExitsAlready' }, ALERT_TYPE.ERROR);
      break;
    case 4167:
      HHAlert({ id: 'alert.error.invalidCouponAmount' }, ALERT_TYPE.ERROR);
      break;
    case 4168:
      HHAlert({ id: 'alert.error.internalServer' }, ALERT_TYPE.ERROR);
      break;
    case 4169:
      HHAlert({ id: 'alert.error.stripeAccountExist' }, ALERT_TYPE.ERROR);
      break;
    case 4170:
      HHAlert({ id: 'alert.error.multipleAccountDetected' }, ALERT_TYPE.ERROR);
      break;
    case 4171:
      HHAlert(
        { id: 'alert.error.participantsRefundDDLGTEventStart' },
        ALERT_TYPE.ERROR
      );
      break;
    case 4172:
      HHAlert({ id: 'alert.error.invalidCouponExpiredTime' }, ALERT_TYPE.ERROR);
      break;
    case 4173:
      HHAlert({ id: 'alert.error.videoNotFound' }, ALERT_TYPE.ERROR);
      break;
    case 4174:
      HHAlert({ id: 'alert.error.invalidFileType' }, ALERT_TYPE.ERROR);
      break;
    case 4019:
      HHAlert({ id: 'alert.error.emailVerifiedAlready' }, ALERT_TYPE.ERROR);
      break;
    case 4022:
      HHAlert(
        { id: 'alert.error.emailVerificationCodeExpired' },
        ALERT_TYPE.ERROR
      );
      break;
    case 6001:
      HHAlert({ id: 'alert.error.actionsTooFreq' }, ALERT_TYPE.ERROR);
      break;
    case 4124:
      HHAlert({ id: 'alert.error.invalidIP' }, ALERT_TYPE.ERROR);
      break;
    case 4123:
      HHAlert({ id: 'alert.error.accountExists' }, ALERT_TYPE.ERROR);
      break;
    case 4126:
      HHAlert({ id: 'alert.error.actionsTooFreq' }, ALERT_TYPE.ERROR);
      break;
    case 4018:
      HHAlert(
        { id: 'alert.error.accountAlreadyEmailVerified' },
        ALERT_TYPE.ERROR
      );
      break;
    case 4127:
      HHAlert(
        { id: 'alert.error.verificationEmailResendExceedLimit' },
        ALERT_TYPE.ERROR
      );
      break;
    case 4013:
      HHAlert({ id: 'alert.error.failedToSendEmail' }, ALERT_TYPE.ERROR);
      break;
    case 4128:
      HHAlert({ id: 'alert.error.invalidVerificationCode' }, ALERT_TYPE.ERROR);
      break;
    case 5001:
      HHAlert({ id: 'alert.error.actionsTooFreq' }, ALERT_TYPE.ERROR);
      break;
    default:
      HHAlert({ id: 'alert.error.invalidInput' }, ALERT_TYPE.ERROR);
      hlog(code);
  }
};

// Users
export const fetchPublicUserProfile = (
  userName,
  callback,
  errHandler
) => async (dispatch, getState) => {
  const requestBody = { token: getState().user.token };
  try {
    const res = await HHRequest(API.PUBLIC_USER_PROFILE(userName), requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (callback) callback(res);
    }
    if (errHandler) errHandler(res);
  } catch (err) {
    hlog(err);
  }
};

export const verifyUserEmail = token => async dispatch => {
  try {
    const postVerifyEmail = () => {
      dispatch(redirectToLastViewedEssentialPage());
    };

    const res = await HHRequest(API.USER_EMAIL_CONFIRM(token));
    handleResponseCode(res.code);
    if (res.code === 200) {
      HHAlert({ id: 'alert.success.verifyEmail' }, ALERT_TYPE.SUCCESS, {
        onClose: postVerifyEmail,
        autoClose: 8000
      });
      dispatch({ type: ActionTypes.SET_USER_EMAIL_VERIFIED });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchUserProfile = callback => async (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token };

    const res = await HHRequest(API.USER_PROFILE, requestBody);
    const userProfile = res.response.basicInfo;
    const userId = userProfile.id;

    mixpanel.identify(userId);
    mixpanel.track('Successful login');
    mixpanel.people.set({
      $email: userProfile.email,
      $lastName: userProfile.lastName,
      $firstName: userProfile.firstName
    });

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({ type: ActionTypes.USER_FETCH_INFO, payload: res.response });

      // reset step tutorial if new user
      if (res.response.basicInfo.newUser) {
        dispatch({ type: ActionTypes.RESET_INTRO });
      }
      if (callback) callback(res.response);
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchUserGithubRepos = githubId => async dispatch => {
  if (githubId) {
    try {
      axios
        .get(`https://api.github.com/users/${githubId}/repos`)
        .then(res => {
          if (res.status === 200) {
            dispatch({
              type: ActionTypes.USER_FETCH_GITHUB_REPOS,
              payload: res.data || []
            });
          }
        })
        .catch(err => {
          hlog(err);
        });
    } catch (err) {
      hlog(err);
    }
  }
};

export const resetUserGithubRepos = () => ({
  type: ActionTypes.USER_RESET_GITHUB_REPOS
});

export const resetGithubState = state => dispatch => {
  dispatch({ type: ActionTypes.USER_GITHUB_STATE, payload: state });
};

export const fetchGithubID = state => dispatch => {
  dispatch({ type: ActionTypes.USER_GITHUB_ID, payload: state });
};

export const resetLinkedinState = state => dispatch => {
  dispatch({ type: ActionTypes.USER_LINKEDIN_STATE, payload: state });
};

export const clearThirtPartyInfo = () => dispatch => {
  dispatch({ type: ActionTypes.USER_THIRD_PARTY_INFO_CLEAN });
};

export const setSignupRole = role => dispatch => {
  dispatch({ type: ActionTypes.USER_SIGNUP_ROLE, payload: role });
};

export const fetchThirdParty = (payload, callback) => async dispatch => {
  try {
    const requestBody = {
      tempCode: payload.code,
      thirdPartyType: payload.from,
      state: payload.state,
      redirectUrl: payload.redirectUrl
    };

    const res = await HHRequest(API.USER_FETCH_THIRD_PARTY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
        dispatch(
          fetchUserProfile(() => {
            if (payload.from === 'Github') {
              dispatch({
                type: ActionTypes.USER_GITHUB_ID,
                payload: res.githubUsername
              });
            }
            dispatch(redirectToLastViewedEssentialPage());
          })
        );
      } else if (callback) {
        const _payload = {
          id: res.thirdPartyInfo.id,
          email: res.thirdPartyInfo.email,
          from: payload.from,
          firstName: get(res, 'thirdPartyInfo.firstName', null),
          lastName: get(res, 'thirdPartyInfo.lastName', null),
          username: res.username,
          ifThirdPartyEmailExist: res.ifThirdPartyEmailExist,
          ifHHAccWithSameEmailExist: res.ifHHAccWithSameEmailExist,
          hidePasswdFromSignup: true,
          githubUsername: res.thirdPartyInfo.githubUsername
        };
        dispatch({
          type: ActionTypes.USER_THIRD_PARTY_INFO,
          payload: _payload
        });
        if (res.ifThirdPartyEmailExist && !res.ifHHAccWithSameEmailExist) {
          dispatch({ type: ActionTypes.USER_SIGNUP, payload: { token: null } });
        }
        callback(res);
      }
    }
  } catch (error) {
    hlog(error);
  }
};

export const backendSocialLogin = (payload, callback) => async dispatch => {
  // for github/linkedin currently
  try {
    const requestBody = {
      tempCode: payload.code,
      thirdPartyType: payload.from,
      state: payload.state,
      redirectUrl: payload.redirectUrl
    };

    const res = await HHRequest(API.USER_FETCH_THIRD_PARTY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
        dispatch(
          fetchUserProfile(() => {
            if (payload.from === 'Github') {
              dispatch({
                type: ActionTypes.USER_GITHUB_ID,
                payload: res.githubUsername
              });
            }
            dispatch(redirectToLastViewedEssentialPage());
          })
        );
      } else if (callback) {
        const _payload = {
          id: res.thirdPartyInfo.id,
          email: res.thirdPartyInfo.email,
          from: payload.from,
          firstName: get(res, 'thirdPartyInfo.firstName', null),
          lastName: get(res, 'thirdPartyInfo.lastName', null),
          username: res.username,
          ifThirdPartyEmailExist: res.ifThirdPartyEmailExist,
          ifHHAccWithSameEmailExist: res.ifHHAccWithSameEmailExist,
          hidePasswdFromSignup: true,
          githubUsername: res.thirdPartyInfo.githubUsername
        };
        if (!res.ifHHAccWithSameEmailExist && res.ifThirdPartyEmailExist) {
          dispatch({
            type: ActionTypes.USER_THIRD_PARTY_INFO,
            payload: _payload
          });
        }
        callback(res);
      }
    }
  } catch (error) {
    hlog(error);
  }
};

export const socialLogin = (payload, callback) => async dispatch => {
  try {
    const requestBody = {
      thirdPartyType: payload.from,
      thirdPartyIdentification: payload.id,
      thirdPartyEmail: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName
    };

    const res = await HHRequest(API.USER_CHECK_THIRD_PARTY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
        dispatch(
          fetchUserProfile(() => {
            dispatch(redirectToLastViewedEssentialPage());
          })
        );
      } else if (callback) {
        const _payload = {
          ...payload,
          username: res.username,
          ifThirdPartyEmailExist: res.ifThirdPartyEmailExist,
          ifHHAccWithSameEmailExist: res.ifHHAccWithSameEmailExist,
          hidePasswdFromSignup: true
        };

        dispatch({
          type: ActionTypes.USER_THIRD_PARTY_INFO,
          payload: _payload
        });
        if (!res.ifHHAccWithSameEmailExist) {
          dispatch({ type: ActionTypes.USER_SIGNUP, payload: { token: null } });
        }
        callback(res);
      }
    }
  } catch (error) {
    hlog(error);
  }
};

export const googleLoginViaLogin = (payload, callback) => async dispatch => {
  try {
    const { googleUser } = payload;
    const requestBody = {
      thirdPartyType: payload.from,
      thirdPartyIdentification: payload.id,
      thirdPartyEmail: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName
    };

    const res = await HHRequest(API.USER_CHECK_THIRD_PARTY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
        dispatch(
          fetchUserProfile(() => {
            dispatch(redirectToLastViewedEssentialPage());
          })
        );
      } else if (callback) {
        if (!res.ifHHAccWithSameEmailExist && !res.isThirdPartyInfoObjExist) {
          const _payload = {
            id: payload.id,
            email: payload.email,
            from: payload.from,
            firstName: payload.firstName,
            lastName: payload.lastName,
            username: '',
            ifThirdPartyEmailExist: true,
            ifHHAccWithSameEmailExist: res.ifHHAccWithSameEmailExist,
            hidePasswdFromSignup: true,
            githubUsername: '',
            googleTokenId: googleUser.getAuthResponse().id_token
          };
          dispatch({
            type: ActionTypes.USER_THIRD_PARTY_INFO,
            payload: _payload
          });
        }
        callback(res);
      }
    }
  } catch (err) {
    hlog(err);
  }
};

export const googleLogin = (payload, callback) => async dispatch => {
  try {
    const requestBody = {
      thirdPartyType: payload.from,
      thirdPartyIdentification: payload.id,
      thirdPartyEmail: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName
    };

    const res = await HHRequest(API.USER_CHECK_THIRD_PARTY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
        dispatch(
          fetchUserProfile(() => {
            dispatch(redirectToLastViewedEssentialPage());
          })
        );
      } else if (callback) {
        if (!res.ifHHAccWithSameEmailExist && !res.isThirdPartyInfoObjExist) {
          const _payload = {
            id: payload.id,
            email: payload.email,
            from: payload.from,
            firstName: payload.firstName,
            lastName: payload.lastName,
            username: '',
            ifThirdPartyEmailExist: true,
            ifHHAccWithSameEmailExist: res.ifHHAccWithSameEmailExist,
            hidePasswdFromSignup: true,
            githubUsername: ''
          };
          dispatch({
            type: ActionTypes.USER_THIRD_PARTY_INFO,
            payload: _payload
          });
        }
        callback(res);
      }
    }
  } catch (error) {
    hlog(error);
  }
};

export const cancelSocialLogin = payload => async dispatch => {
  try {
    if (
      payload.thirdPartyType === 'Github' ||
      payload.thirdPartyType === 'Linkedin'
    ) {
      const res = await HHRequest(API.USER_CANCEL_SOCIAL_LOGIN, payload);
      handleResponseCode(res.code);
      if (res.code === 200) {
        dispatch({ type: ActionTypes.USER_CANCEL_SOCIAL_LOGIN });
      }
    } else {
      dispatch({ type: ActionTypes.USER_CANCEL_SOCIAL_LOGIN });
    }
  } catch (err) {
    hlog(err);
  }
};

export const accountSignUp = values => async dispatch => {
  try {
    const requestBody = { ...values };
    requestBody.email = toLower(requestBody.email);
    if (!isEmpty(requestBody.password)) {
      requestBody.password = HHEncrypt(requestBody.password);
    }
    if (has(requestBody, 'confirmPassword')) {
      delete requestBody.confirmPassword;
    }

    const { data } = await axios.post(API.ACCOUNT_REGISTER, requestBody);
    handleResponseCode(data.code);
    if (data.code === 200) {
      const { response } = data;
      const basicInfo = {
        id: get(response, 'intercom.user_id'),
        username: values.username,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        isEmailVerified: true,
        signupRole: values.signupRole,
        isProfileCompleted: true
      };
      dispatch({
        type: ActionTypes.USER_THIRD_PARTY_INFO_CLEAN
      });
      dispatch({
        type: ActionTypes.ACCOUNT_REGISTER,
        payload: { token: response.token, basicInfo }
      });
      dispatch(fetchUserProfile(dispatch(push('/signup/profile'))));
      // dispatch(push('/signup/profile'));
    }
    return data.code === 200;
  } catch (err) {
    hlog(err);
    return false;
  }
};

export const signUp = values => async dispatch => {
  try {
    const requestBody = { ...values };
    requestBody.email = toLower(requestBody.email);
    if (requestBody.newPassword) {
      requestBody.password = HHEncrypt(requestBody.newPassword);
    } else {
      requestBody.password = requestBody.newPassword;
    }
    delete requestBody.newPassword;

    const res = await HHRequest(API.USER_SIGNUP, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (res.token) {
        dispatch({
          type: ActionTypes.USER_SIGNUP,
          payload: { token: res.token }
        });

        dispatch(push('/signup/basic'));
      } else {
        HHAlert({ id: 'alert.error.duplicateEmail' }, ALERT_TYPE.WARNING);
        dispatch({
          type: ActionTypes.USER_THIRD_PARTY_INFO,
          payload: { email: requestBody.email }
        });
        dispatch(push('/login'));
      }
    }
    return res.code !== 200;
  } catch (err) {
    hlog(err);
  }
  return true;
};

export const signInQRCode = (token, callback) => async dispatch => {
  try {
    dispatch({ type: ActionTypes.USER_LOGIN, payload: { token } });
    dispatch(fetchUserProfile(callback));
  } catch (err) {
    hlog(err);
  }
};

export const signIn = payload => async dispatch => {
  try {
    const requestBody = { ...payload };
    requestBody.email = toLower(requestBody.email);
    requestBody.password = HHEncrypt(requestBody.password);

    const res = await HHRequest(API.USER_LOGIN, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({ type: ActionTypes.USER_LOGIN, payload: res });
      dispatch(
        fetchUserProfile(() => {
          dispatch(redirectToLastViewedEssentialPage());
        })
      );
    }
    return res.code !== 200;
  } catch (err) {
    hlog(err);
  }
  return true;
};

export const accountSignIn = payload => async dispatch => {
  try {
    const requestBody = { ...payload };
    requestBody.email = toLower(requestBody.email);
    requestBody.password = HHEncrypt(requestBody.password);

    const res = await HHRequest(API.HACKHUB_ACCOUNT_LOGIN, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.HACKHUB_ACCOUNT_LOGIN,
        payload: res.response
      });
      dispatch(
        fetchUserProfile(() => {
          dispatch(redirectToLastViewedEssentialPage());
        })
      );
    }
    return res.code !== 200;
  } catch (err) {
    hlog(err);
  }
  return true;
};

export const updateUserPermission = callback => async (dispatch, getState) => {
  const { token } = getState().user;
  if (token) {
    try {
      const requestBody = { token: getState().user.token };
      const res = await HHRequest(API.USER_PERMISSION_UPDATE, requestBody);
      handleResponseCode(res.code);
      if (res.code === 200) {
        dispatch({ type: ActionTypes.USER_UPDATE_PERMISSION, payload: res });
        if (callback) callback();
      }
    } catch (err) {
      hlog(err);
    }
  }
};

export const redirectToLastViewedEssentialPage = () => async (
  dispatch,
  getState
) => {
  const { lastViewedEssentialPage } = getState().user;
  const target = lastViewedEssentialPage || '/';
  dispatch(push(target));
  dispatch(resetLastViewedEssentialPage());
};

export const requestResetPassword = ({ email }) => async () => {
  try {
    const requestBody = { email: toLower(email) };
    const res = await HHRequest(API.USER_PASSWORD_RESET, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      HHAlert({ id: 'alert.info.checkEmailToResetPassword' }, ALERT_TYPE.INFO);
    }
    return res.code !== 200;
  } catch (err) {
    hlog(err);
  }
  return true;
};

export const resetPassword = (newPassword, code) => async dispatch => {
  try {
    const requestBody = { password: HHEncrypt(newPassword), code };
    const res = await HHRequest(API.USER_NEW_PASSWORD, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch(push('/login'));
    }
    return res.code !== 200;
  } catch (err) {
    hlog(err);
  }
  return true;
};

export const updatePassword = requestBody => dispatch =>
  HHRequest(API.USER_UPDATE_PASSWORD, requestBody).then(
    res => {
      handleResponseCode(res.code);
      if (res.code === 200) {
        dispatch({ type: ActionTypes.USER_UPDATE_TOKEN, payload: res.token });
        HHAlert({ id: 'alert.success.updatePassword' }, ALERT_TYPE.SUCCESS);
        return res;
      }
      return { ok: false, err: 'Something went wrong' };
    },
    err => ({ ok: false, err })
  );

export const disableNewUserStatus = () => async (dispatch, getState) => {
  const { token } = getState().user;
  if (token) {
    try {
      const requestBody = { token };
      const { data } = await axios.post(
        API.USER_UPDATE_NEW_USER_FIELD,
        requestBody
      );
      handleResponseCode(data.code);
      if (data.code === 200) {
        dispatch({ type: ActionTypes.DISABLE_PROFILE_TUTORIAL_STEPS });
      }
    } catch (err) {
      hlog(err);
    }
  }
};

export const addUserEventApplied = eventSlug => async dispatch => {
  dispatch({ type: ActionTypes.USER_EVENTAPPLIED, payload: eventSlug });
};

export const enableIntercom = () => ({
  type: ActionTypes.ENABLE_INTERCOM
});

export const disableIntercom = () => ({
  type: ActionTypes.DISABLE_INTERCOM
});

export const analyzeResume = data => async dispatch => {
  try {
    const res = await axios.post(API.RESUME_ANALYZE, { url: data.resumeUrl });
    const resumeAnalysis = await JSON.stringify(res.data);
    dispatch(setResumeAnalysis(resumeAnalysis));
    dispatch(updateUserProfile({ ...data, resumeAnalysis }));
  } catch (err) {
    hlog(err);
  }
};

export const analyzeResumeScore = fileUrl => async (dispatch, getState) => {
  try {
    const { id, tags } = getState().user.profile.basicInfo;
    const res = await axios.post(API.RESUME_SCORE, {
      fileUrl,
      userId: id,
      userTags: tags
    });
    const { ok, resumeAnalysis } = res.data;
    if (ok) {
      dispatch(setResumeAnalysis(resumeAnalysis));
      dispatch(updateUserProfile({ resumeAnalysis }));
    }
    return res;
  } catch (err) {
    hlog(err);
    return err;
  }
};

export const setResumeAnalysis = analysis => ({
  type: ActionTypes.SET_USER_RESUME_ANALYSIS,
  payload: analysis
});

export const updateUserProfile = (data, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody =
      data.firstName && data.lastName
        ? { ...data }
        : { token: getState().user.token, ...data };
    const res = await HHRequest(API.USER_PROFILE_UPDATE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (data.firstName && data.lastName) {
        dispatch({
          type: ActionTypes.USER_SIGNUP,
          payload: { token: res.token }
        });
      }
      dispatch(fetchUserProfile(callback));
    }
  } catch (err) {
    hlog(err);
  }
};
export const sendNewSignUpEmail = () => (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token };
    const res = axios.post(API.USER_SIGNUP_EMAIL, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      //  do nothing
    }
  } catch (err) {
    hlog(err);
  }
};

export const updateUserSocialMedia = (data, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { token: getState().user.token, ...data };
    const res = await HHRequest(API.USER_SNS_UPDATE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.USER_UPDATE_SOCIAL_MEDIA,
        payload: data
      });
      if (callback) callback();
    }
  } catch (err) {
    hlog(err);
  }
};

export const userLogout = () => async dispatch => {
  dispatch({ type: ActionTypes.USER_LOGOUT });
  dispatch(push('/login'));
};

export const resendVerification = () => async (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token };
    const res = HHRequest(API.USER_EMAIL_VERIFY, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      standardReturn(res);
    }
  } catch (err) {
    hlog(err);
  }
};

export const updateLastViewedEssentialPage = target => ({
  type: ActionTypes.UPDATE_LAST_VIEWED_ESSENTIAL_PAGE,
  payload: target
});

export const resetLastViewedEssentialPage = () => ({
  type: ActionTypes.RESET_LAST_VIEWED_ESSENTIAL_PAGE
});

export const setUserCurrentTeam = teamId => ({
  type: ActionTypes.SET_USER_CURRENT_TEAM,
  payload: teamId
});

export const setUserPhoneVerified = isPhoneVerified => ({
  type: ActionTypes.SET_USER_PHONE_VERIFIED,
  payload: isPhoneVerified
});

export const sendPhoneCode = (
  { phoneNumber, countryCode, countryDialCode },
  callback
) => async (dispatch, getState) => {
  try {
    const requestBody = {
      token: getState().user.token,
      phoneNumber,
      countryCode,
      countryDialCode
    };
    const res = await HHRequest(API.SEND_PHONE_CODE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (callback) callback();
    }
  } catch (err) {
    hlog(err);
  }
};

export const verifyPhoneCode = (code, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { token: getState().user.token, code };
    const res = await HHRequest(API.VERIFY_PHONE_CODE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (callback) callback();
    }
  } catch (err) {
    hlog(err);
  }
};

// fetch user checkin status
export const checkinStatus = (email, eventSlug, callback) => async (
  dispatch,
  getState
) => {
  const requestBody = { email, eventSlug, token: getState().user.token };
  try {
    const res = await HHAxiosRequest(API.ADMISSION_STATUS_GET, requestBody);

    if (res.status === 200) {
      if (callback) callback(res.data);
    }
  } catch (err) {
    hlog(err);
  }
};

// team displayed on sidebar
export const setUserSelectedTeam = teamId => ({
  type: ActionTypes.SET_USER_SELECTED_TEAM,
  payload: teamId
});

export const switchInTeam = isInTeam => ({
  type: ActionTypes.IN_TEAM,
  payload: isInTeam
});

export const resetCurrentProjectForSubmissionCard = () => ({
  type: ActionTypes.PROJECT_RESET_SINGLE_FOR_SUBMISSION_CARD,
  payload: { isFetching: true }
});

export const fetchCurrentProjectForSubmissionCard = teamId => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { token: getState().user.token };
    const res = await HHRequest(API.TEAM_DETAIL(teamId), requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      passBack(
        dispatch,
        res,
        ActionTypes.PROJECT_FETCH_SINGLE_FOR_SUBMISSION_CARD,
        res.project
      );
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchCurrentProject = projectId => async (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token };
    const res = await HHRequest(API.TEAM_DETAIL(projectId), requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      passBack(dispatch, res, ActionTypes.PROJECT_FETCH_SINGLE, res.project);
    }
  } catch (err) {
    hlog(err);
  }
};

export const updateCurrentProject = data => ({
  type: ActionTypes.PROJECT_UPDATE_SINGLE,
  payload: data
});

export const resetCurrentProject = () => ({
  type: ActionTypes.PROJECT_RESET_SINGLE,
  payload: { isFetching: true, pyamentStatus: '' }
});

export const fetchProjectDetails = teamId => async (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token };
    const res = await HHRequest(API.TEAM_DETAIL(teamId), requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      standardReturn(res);
    }
  } catch (err) {
    hlog(err);
  }
};

// export const viewByInviteCode = () => async (dispatch, getState) => {
//   const { token } = getState().user;
//   HHRequest(API.PROJECT_VIEW_INVITE(token)).then(res => standardReturn(res));
// };

export const fetchTags = () => async dispatch => {
  try {
    const res = await HHRequest(API.TAG_LIST, {});
    handleResponseCode(res.code);
    if (res.code === 200) {
      passBack(dispatch, res, ActionTypes.FETCH_TAGS, res.tags);
    }
  } catch (err) {
    hlog(err);
  }
};

export const addTag = newTag => ({
  type: ActionTypes.ADD_TAG,
  payload: {
    key: `user_created_tag_${newTag}`,
    value: newTag,
    text: newTag
  }
});

// Events
export const acceptCandidate = payload => ({
  type: ActionTypes.ACCEPT_CMS_EVENT_CANDIDATE,
  payload
});

export const rejectCandidate = payload => ({
  type: ActionTypes.REJECT_CMS_EVENT_CANDIDATE,
  payload
});

export const verifyInviteToken = eventSlug => ({
  type: ActionTypes.SET_EVENT_TEMPORARILY_ACCESSIBLE,
  payload: { eventSlug, status: true }
});

export const joinEvent = eventSlug => async (dispatch, getState) => {
  try {
    const requestBody = { token: getState().user.token, eventSlug };
    const res = await HHRequest(API.EVENT_JOIN, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.JOIN_EVENT,
        payload: res.participants,
        eventSlug
      });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchEvents = () => async (dispatch, getState) => {
  try {
    const { token } = getState().user;
    const requestBody = token ? { token } : {};

    const res = await HHRequest(API.EVENT_LIST, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_EVENTS,
        payload: res.events,
        userInEvents: res.userInEvents
      });
    }
  } catch (err) {
    hlog(err);
  }
};

export const fetchSingleEvent = (eventSlug, callback) => async (
  dispatch,
  getState
) => {
  try {
    const { token } = getState().user;
    const requestBody = token ? { eventSlug, token } : { eventSlug };
    const res = await HHRequest(API.EVENT_DETAIL, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_SINGLE_EVENT,
        payload: { event: res.event, userInfo: res.userInfo },
        eventId: res.event.id
      });
      if (callback) callback({ event: res.event, userInfo: res.userInfo });
    }
  } catch (err) {
    hlog(err);
  }
};

export const resetEvents = () => ({ type: ActionTypes.RESET_EVENTS });

// Teams

export const fetchTeamList = (eventId, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { eventId, token: getState().user.token };
    const res = await HHRequest(API.TEAM_LIST, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_TEAM_LIST,
        payload: res.teams,
        eventId
      });
      if (callback) callback(res);
    }
  } catch (err) {
    hlog(err);
  }
};

export const updateTeamMatchingPercent = (eventId, teams) => ({
  type: ActionTypes.UPDATE_TEAM_MATCHING_PERCENT,
  payload: teams,
  eventId
});

export const submitEventProject = (data, event, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = {
      token: getState().user.token,
      eventId: event.id,
      name: data.fileName,
      ...data
    };

    const res = await HHRequest(API.EVENT_SUBMIT, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.SUBMIT_EVENT,
        payload: res.submission,
        eventId: event.id
      });
      if (callback) callback();
    } else {
      dispatch(fetchTeamList(event.id));
      dispatch(push(`/event/${event.slug}`));
      dispatch(setUserCurrentTeam(-1));
    }
  } catch (err) {
    hlog(err);
    /* handle error */
  }
};

export const teamInvite = (emails, teamId) => async () => {
  try {
    const requestBody = { emails, teamId };
    const res = await HHRequest(API.TEAM_INVITE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      HHAlert({ id: 'alert.success.sendInvitationEmail' }, ALERT_TYPE.SUCCESS);
    }
  } catch (err) {
    hlog(err);
  }
};

// Event Submissions

// export const fetchEventSubmissions = (eventId, callback) => async (
//   dispatch,
//   getState
// ) => {
//   try {
//     const { token } = getState().user;
//     const requestBody = { eventId, token };
//     const res = await HHRequest(API.EVENT_SUBMSSION_LIST, requestBody);
//     handleResponseCode(res.code);
//     if (res.code === 200) {
//       dispatch({
//         type: ActionTypes.FETCH_EVENT_SUBMISSIONS,
//         payload: res.submissions,
//         eventId
//       });
//       if (callback) callback(res);
//     }
//   } catch (err) {
//     hlog(err);
//   }
// };

export const submitSubmissionMarks = (
  submissionId,
  judgingScore,
  comment
) => async (dispatch, getState) => {
  try {
    const requestBody = {
      token: getState().user.token,
      submissionId,
      judgingScore,
      comment
    };
    const res = await HHRequest(API.MENTOR_MARKING, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      if (window.heap !== undefined) {
        window.heap.clearEventProperties();
        window.heap.addEventProperties({ JudgeSubmitMarkStatus: 'success' });
      }
      hlog('OK, Submitted');
      HHAlert(
        { id: 'alert.success.judgingResultSubmitted' },
        ALERT_TYPE.SUCCESS
      );
    } else if (window.heap !== undefined) {
      window.heap.clearEventProperties();
      window.heap.addEventProperties({
        JudgeSubmitMarkStatus: 'error code received'
      });
    }
  } catch (err) {
    if (window.heap !== undefined) {
      window.heap.clearEventProperties();
      window.heap.addEventProperties({
        JudgeSubmitMarkStatus: 'request failed'
      });
    }
    hlog(err);
  }
};

// Event Commnets

export const fetchEventComment = eventId => async dispatch => {
  try {
    const requestBody = { eventId };
    const res = await HHRequest(API.EVENT_COMMENT_LIST, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.FETCH_EVENT_COMMENTS,
        payload: res.comments,
        eventId
      });
    }
  } catch (err) {
    hlog(err);
  }
};

export const createEventComment = (eventId, content, callback) => async (
  dispatch,
  getState
) => {
  try {
    const requestBody = { token: getState().user.token, eventId, content };
    const res = await HHRequest(API.EVENT_COMMENT_CREATE, requestBody);

    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.CREATE_EVENT_COMMENT,
        payload: res.comments,
        eventId
      });
      if (callback) callback(res);
    }
  } catch (err) {
    /* handle error */
    hlog(err);
  }
};

export const replyEventComment = (
  eventId,
  replyToId,
  content,
  callback
) => async (dispatch, getState) => {
  try {
    const requestBody = {
      token: getState().user.token,
      eventId,
      content,
      replyToId
    };
    const res = await HHRequest(API.EVENT_COMMENT_REPLY_CREATE, requestBody);
    handleResponseCode(res.code);
    if (res.code === 200) {
      dispatch({
        type: ActionTypes.REPLY_EVENT_COMMENT,
        payload: res.comments,
        eventId
      });
      if (callback) callback(res);
    }
  } catch (err) {
    hlog(err);
  }
};

// Loader
export const activateLoader = () => ({
  type: ActionTypes.LOADER_ACTIVATE
});

export const deactivateLoader = () => ({
  type: ActionTypes.LOADER_DEACTIVATE
});

export const activateEventFormCoverImageLoader = () => ({
  type: ActionTypes.EVENT_FORM_COVER_IMAGE_LOADER_ACTIVATE
});

export const deactivateEventFormCoverImageLoader = () => ({
  type: ActionTypes.EVENT_FORM_COVER_IMAGE_LOADER_DEACTIVATE
});

// View
export const resetView = () => ({
  type: ActionTypes.RESET_VIEW
});

export const setEventTeamSidebarTab = tab => ({
  type: ActionTypes.SET_EVENT_TEAM_SIDEBAR_TAB,
  payload: tab
});

export const setEventDetailTeamsContentView = view => ({
  type: ActionTypes.SET_EVENT_DETAIL_TEAMS_CONTENT_VIEW,
  payload: view
});

export const setFilterVal = val => ({
  type: ActionTypes.SET_FILTER_VAL,
  payload: val
});

export const setSortMethod = method => ({
  type: ActionTypes.SET_SORT_METHOD,
  payload: method
});

export const updateEventUserInfo = payload => ({
  type: ActionTypes.UPDATE_EVENT_USER_INFO,
  payload
});

export const emailVerficationSuccess = isFinished => dispatch => {
  if (isFinished) {
    dispatch({
      type: ActionTypes.EMAIL_VERIFICATION_SUCCESS
    });
  } else {
    HHAlert(
      { id: 'alert.error.emailVerificationStateUpdateFailed' },
      ALERT_TYPE.ERROR
    );
  }
};

export const acceptPolicy = () => ({
  type: ActionTypes.ACCEPT_POLICY
});

// Companies



// WEBPACK FOOTER //
// ./src/components/actions/index.js